import { render, staticRenderFns } from "./SmsMtQueue.vue?vue&type=template&id=fdfc7fba&scoped=true"
import script from "./SmsMtQueue.vue?vue&type=script&lang=js"
export * from "./SmsMtQueue.vue?vue&type=script&lang=js"
import style0 from "./SmsMtQueue.vue?vue&type=style&index=0&id=fdfc7fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfc7fba",
  null
  
)

export default component.exports